module.exports = ":host /deep/ table *,\n:host /deep/ #example {\n    border: none !important;\n}\n\na, a:focus, a:hover {\n    cursor: pointer;\n}\n\n.filters {\n    margin-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/certificates/components/details/certificate-used/certificate-used.component.css
// module id = ./src/app/organization/components/certificates/components/details/certificate-used/certificate-used.component.css
// module chunks = main